var vendorCategoryServices = angular.module('vendorCategoryServices',['sharedServices','configService']);


vendorCategoryServices.factory('vendorCategory',function($http,config){
	var vendorCategory = function(token,randomNumber,category,city,loc,venueType) {
		// console.log(venueType);
		var url;
		if(loc != '') {
			url = config.domain + '/api/v1/vendor/filter?version=1.4&token='+token+'&random='+randomNumber+'&filter=1&offset=0&limit=40&city_slug='+city+'&category_slug='+category+'&locality_slug='+loc;
		} else {
			if(category !== 'family-makeup') {
				url = config.domain + '/api/v1/vendor/filter?version=1.4&token=' + token + '&random=' + randomNumber + '&filter=1&offset=0&limit=40&city_slug=' + city + '&category_slug=' + category;
			}
			else {
				url = config.domain + '/api/v1/vendor/filter?version=1.4&token=' + token + '&random=' + randomNumber + '&filter=1&offset=0&limit=40&city_slug=all&category_slug=' + category;
			}
		}
		if(venueType != ''){
			url += '&venue_type_slug='+venueType;
		}
		return $http.get(url);
	}
	return vendorCategory;
});
vendorCategoryServices.factory('vendorCategoryName',function($http,config){
	var vendorCategoryName = function(token) {
		return $http.get(config.domain + '/api/v1/masters?version=1.1&token='+token)
	}
	return vendorCategoryName;
});

vendorCategoryServices.factory('vendorNewData',function($http,config){
	var vendorNewData = function(token) {
		return $http.get(config.domain + '/api/v1/vendor/list?version=1.1&token='+token+'&filter=1')
	}
	return vendorNewData;
});
vendorCategoryServices.factory('getVendorNew',function($http,config){
	var getVendorNew = function(token,cityId,others) {
		return $http.get(config.domain + '/api/v1/vendor/list?version=1.1&token='+token+'&filter=1&city_id='+cityId+'&other_city='+others)
	}
	return getVendorNew;
});

vendorCategoryServices.factory('getVendorList',function($http,config) {
	var randomNumber = Math.floor(1000 + Math.random() * 9000);
	var getVendorList = function(token,id) {
		return $http.get(config.domain + '/api/v1/vendor/filter?version=1.3&token='+token+'&category='+id+'&random='+randomNumber+'&filter=1')
	}
	return getVendorList;
});
vendorCategoryServices.factory('getVendorListFilter',function($http,config) {
	var randomNumber = Math.floor(1000 + Math.random() * 9000);
	var getVendorListFilter = function(token,randomNumber,title,option,cityId,categoryId,getfilter) {
		return $http.get(config.domain + '/api/v1/vendor/search?version=1.2&token='+token+'&category='+categoryId+'&random='+randomNumber+'&'+option+'&city='+cityId+'&'+getfilter)
		}
	return getVendorListFilter;
});
vendorCategoryServices.factory('getSearchResult',function($http,config) {
	var getSearchResult = function(token,value) {
		return $http.get(config.domain + '/api/v1/search/vendor?version=1.1&token=' + token + '&keyword=' + value + '&offset=0&limit=6');
		// return $http.get(config.domain + '/api/v1/search?version=1.2'+'&q='+value+'&suggest=true'+'&token='+token+'&type='+'vendor_filters');
		}
	return getSearchResult;
});


vendorCategoryServices.factory('getVendorsFeed', function($http,$timeout, config) {
	var getVendorsFeed = function(token, cityId, categoryId, filter, filterLength, randomNumber, locationFilter,postRangeString) {
		//console.log("baharfilter",filter);
	  this.items = [];
	  this.count = '';
	  this.busy = false;
	  this.after = '';
	  this.token = token;
	  this.cityId = cityId;
	  this.categoryId = categoryId;
	  this.offset = 0;
	  this.noData = false;
	  this.flag = 0;
	  this.showValue;
	  this.filter = filter;
	  this.locationFilter = locationFilter;
	  this.filterLength = filterLength;
	  this.filterSelected = true;
	  this.randomNumber = randomNumber;
	  this.postRangeString = postRangeString;
	  this.allLoaded = false;
	  this.limit = '40';
	  this.clickNo = 0;
	  this.previousPath = '';
	  this.currentPath = '';
	  this.disallowInfiniteScroll = false;
	};

	var callGA = function(categoryId,count) {
		if (categoryId == 10) {
			var show_more = 'show_more_venue_'+count;
			ga('send','event','venue_leads',show_more,'show_more_results');
		} else {
			var show_more = 'show_more_'+count;
			ga('send','event','otherVendor_leads',show_more,'show_more_results');
		}
	}

	getVendorsFeed.prototype.nextPage = function(clicked) {
	  if (this.busy) return;
	  this.busy = true;
	  this.showValue = 0;
	  if (this.currentPath == '') {
    	this.currentPath = window.location.href;
    } else {
    	this.previousPath = this.currentPath;
    	this.currentPath = window.location.href;
    }
    if (this.currentPath !== this.previousPath) {
    	this.paid = true;
    }
	  if(this.locationFilter == undefined && this.postRangeString == undefined) {
		var url = this.filter == 'filter_option=' ? config.domain + '/api/v1/vendor/filter?version=1.4&token='+this.token+'&category='+this.categoryId+'&random='+this.randomNumber+'&offset='+this.offset+'&limit='+this.limit+'&city='+this.cityId : config.domain + '/api/v1/vendor/filter?version=1.4&token='+this.token+'&category='+this.categoryId+'&random='+this.randomNumber+'&offset='+this.offset+'&limit='+this.limit+'&city='+this.cityId+'&'+this.filter;
	  } else if(this.locationFilter != undefined && this.postRangeString == undefined) {
		var url = this.filter == 'filter_option=' ? config.domain + '/api/v1/vendor/filter?version=1.4&token='+this.token+'&category='+this.categoryId+'&random='+this.randomNumber+'&offset='+this.offset+'&limit='+this.limit+'&city='+this.cityId+'&'+this.locationFilter : config.domain + '/api/v1/vendor/filter?version=1.4&token='+this.token+'&category='+this.categoryId+'&random='+this.randomNumber+'&offset='+this.offset+'&limit='+this.limit+'&city='+this.cityId+'&'+this.filter+'&'+this.locationFilter;
	  } else if(this.locationFilter == undefined && this.postRangeString != undefined) {
	  	var url = this.filter == 'filter_option=' ? config.domain + '/api/v1/vendor/filter?version=1.4&token='+this.token+'&category='+this.categoryId+'&random='+this.randomNumber+'&offset='+this.offset+'&limit='+this.limit+'&city='+this.cityId+'&'+this.postRangeString : config.domain + '/api/v1/vendor/filter?version=1.4&token='+this.token+'&category='+this.categoryId+'&random='+this.randomNumber+'&offset='+this.offset+'&limit='+this.limit+'&city='+this.cityId+'&'+this.filter+'&'+this.postRangeString;
	  } else {
	  	var url = this.filter == 'filter_option=' ? config.domain + '/api/v1/vendor/filter?version=1.4&token='+this.token+'&category='+this.categoryId+'&random='+this.randomNumber+'&offset='+this.offset+'&limit='+this.limit+'&city='+this.cityId+'&'+this.postRangeString+'&'+this.locationFilter : config.domain + '/api/v1/vendor/filter?version=1.4&token='+this.token+'&category='+this.categoryId+'&rancd wedom='+this.randomNumber+'&offset='+this.offset+'&limit='+this.limit+'&city='+this.cityId+'&'+this.filter+'&'+this.postRangeString+'&'+this.locationFilter;
	  }
	  //console.log("url",url,"postRangeString",this.postRangeString,"filter",this.filter);
	  if(this.filterSelected) {
		  $http.get(url).success(function(data) {
		  	this.count = data.total_count;
		  	if(data.seo && this.offset == 0) {
			  	$('#overallVenue').html(data.seo.footer)
				}
		  	if( data.data ) {
			    var items = data.data;
			    for (var i = 0; i < items.length; i++) {
			      this.items.push(items[i]);
			    }
			    if (data.show_more) {
			    	this.paid = false;
			    	this.disallowInfiniteScroll = true;
			    }else{
			    	this.paid = true;
			    	this.disallowInfiniteScroll = false;
			    }
			    if (data.data.length < 1*this.limit) {
			    	this.paid = false;
			    	this.disallowInfiniteScroll = true;
			    }
			    if (1*this.count <= this.items.length) {
			    	this.allLoaded = true;
			    } else {
			    	this.allLoaded = false;
			    }
			    //console.log("It Is Offstet: "data.offset);
			    this.offset = data.offset;
			    this.busy = false;
			    this.noData = false;
			    this.flag = 1;
			    if (clicked) {
			    	this.clickNo += 1;
			    	callGA(this.categoryId,this.clickNo);
			    }
				} else {
					this.noData = true;
					this.showValue = 1;
				}
		  }.bind(this));
		}
	};
	return getVendorsFeed;
});

vendorCategoryServices.factory('vendorFeedMobile', function($http, config) {
	var vendorFeedMobile = function(token, randomNumber, categoryId, cityId, filterOption, rangeFilter, localities,flag,rating) {
		this.items = [];
		this.busy = false;
		this.count = '';
		this.noData = false;
		this.token = token;
		this.cityId = cityId;
		this.categoryId = categoryId;
		this.offset = 0;
		this.showValue;
		this.randomNumber = randomNumber;
		this.filterOption = filterOption;
		this.rangeFilter = rangeFilter;
		this.localities = localities;
		this.rating = rating;
		this.paid = true;
	  this.paid_limit = '20';
	  this.allLoaded = false;
	  this.limit = '20';
	  this.clickNo = 0;
	  this.currentPath = '';
	  this.previousPath = '';
	  this.disallowInfiniteScroll = false;
	};
	var callGA = function(categoryId,count) {
		if (categoryId == 'wedding-venues') {
			var show_more = 'show_more_venue_'+count;
			ga('send','event','venue_leads',show_more,'show_more_results');
		} else {
			var show_more = 'show_more_'+count;
			ga('send','event','otherVendor_leads',show_more,'show_more_results');
		}
	}

	vendorFeedMobile.prototype.nextPage = function(clicked) {
		// console.log('here?')
		if (this.busy) return;
		this.busy = true;
		this.showValue = 0;
		if (this.currentPath == '') {
    	this.currentPath = window.location.href;
    } else {
    	this.previousPath = this.currentPath;
    	this.currentPath = window.location.href;
    }
    // console.log(this.currentPath,this.previousPath);
    if (this.currentPath !== this.previousPath) {
    	this.paid = true;
    }
		if(this.filterOption && this.filterOption.length) {
			var url = config.domain + '/api/v1/vendor/filter?version=1.4&token='+this.token+'&category_slug='+this.categoryId+'&random='+this.randomNumber+'&offset='+this.offset+'&limit=40&city_slug='+this.cityId+'&filter_option='+this.filterOption+'&'+this.rangeFilter+'&locality='+this.localities+'&rating='+this.rating;
		} else {
			var url = config.domain + '/api/v1/vendor/filter?version=1.4&token='+this.token+'&category_slug='+this.categoryId+'&random='+this.randomNumber+'&offset='+this.offset+'&limit=40&city_slug='+this.cityId+'&'+this.rangeFilter+'&locality='+this.localities+'&rating='+this.rating;
		}
		$http.get(url).success(function(data) {
		  	this.count = data.total_count;
	  	  	if(data.seo && this.offset == 0 && data.seo.footer != "") {
	  	  		$('#overallVenue').css('display','block');
	  	  		$('.r-m-b').css('display','inline');
	  	  		$('#overallVenue').prepend(data.seo.footer)
	  	  		// console.log('overall',$('#overallVenue'))
	  		} else if(data.seo && data.seo.footer == "") {
	  			$('#overallVenue').css('display','none')
	  			$('.r-m-b').css('display','none');
	  		}
		  	if( data.data ) {
			    var items = data.data;
			    for (var i = 0; i < items.length; i++) {
			      this.items.push(items[i]);
			      if (items[i].membership_id == '4') {
			    		this.paid = false;
			    		this.disallowInfiniteScroll = true;
			    	}
			    }
			    if (data.data.length < this.limit) {
			    	this.paid = false;
			    	this.disallowInfiniteScroll = true;
			    }
			    if (1*this.count <= this.items.length) {
			    	this.allLoaded = true;
			    } else {
			    	this.allLoaded = false;
			    }
		  		//console.log("infinitedata",data.data,this.items);
			    //this.feed = false
			    this.offset = this.offset+data.data.length;
			    this.busy = false;
			    this.noData = false;
			    if (clicked) {
			    	this.clickNo += 1;
			    	// console.log(this.clickNo);
			    	callGA(this.categoryId,this.clickNo);
			    }
				} else {
					//this.busy = false;
					this.noData = true;
					this.showValue = 1;
				}
		}.bind(this));
	}
	return vendorFeedMobile;
});

vendorCategoryServices.factory('getVendorsSearchFeed', function($http,$timeout, config) {
	var getVendorsSearchFeed = function(token, searchValue) {
		//console.log("baharfilter",filter);
	  this.items = [];
	  this.busy = false;
	  this.after = '';
	  this.token = token;
	  this.searchValue = searchValue;
	  this.offset = 0;
	  this.noData = false;
	  this.flag = 0;
	  this.totalRecords = '';
	};

	getVendorsSearchFeed.prototype.nextPage = function() {
	  if (this.busy) return;
	  this.busy = true;
	  var url = config.domain + '/api/v1/search/vendor?version=1.1&token='+this.token+'&keyword='+this.searchValue+'&offset='+this.offset+'&limit=12'
	  //console.log("url",url);
	  $http.get(url).success(function(data) {
	  	//console.log(data,"data");
	  	this.totalRecords = data.data.total_records;
	  	if( data.data.vendors.length) {
		    var items = data.data.vendors;
		    for (var i = 0; i < items.length; i++) {
		      this.items.push(items[i]);
		    }
	  		//console.log("infinitedata",data.data,this.items);
		    //this.feed = false
		    this.offset = this.offset+12;
		    this.busy = false;
		    this.noData = false;
		    this.flag = 1;
			} else {
				this.noData = true;
				//this.busy = "Oops NO Data Found";
			}
	  }.bind(this));
	};
	return getVendorsSearchFeed;
});

vendorCategoryServices.factory('vendorCategorySeo',function($http,config) {
	var vendorCategorySeo = function(token,category,city,locality,venueType) {
		var url;

		if (locality != '') {
			url = config.domain + '/api/v1/vendor/seo?city_slug='+city+'&vendor_cat_slug='+category+'&locality_slug='+locality+'&token='+token;
		} else {
			url = config.domain + '/api/v1/vendor/seo?city_slug='+city+'&vendor_cat_slug='+category+'&token='+token;
		}
		if(venueType != ''){
				url += '&venuetype_slug='+venueType;
		}
		return $http.get(url);
	}
	return vendorCategorySeo;
});

vendorCategoryServices.factory("genieService", function($http, config){
	// console.log('genieService Called');
	var genieService = function(token, genieData){
		return $http({
			method: 'POST',
			url: config.domain + '/api/v1/booking-lead?token=' + token,
			data: genieData
		})
	}
	return genieService;
});

vendorCategoryServices.factory("genieSecondaryService", function($http, config){
	// console.log('genieSecondaryService called');
	var genieSecondaryService = function(token, lead_id, genieData){
		console.log(lead_id, genieData);
		return $http({
			method: "PUT",
			url: config.domain + '/api/v1/booking-lead/' + lead_id + "?token=" + token,
			data: genieData
		});
	}
	return genieSecondaryService;
})

vendorCategoryServices.factory('groupBooking', function($http, config) {
	var groupBooking = function(token,bookData) {
		return $http({
      		method: 'post',
      		url: config.domain + '/api/v1/user/book/groupmakeup?token=' + token,
      		data: bookData
    	})
    }
    return  groupBooking;
});
vendorCategoryServices.factory('getRecentData',function($http,config) {
	var getRecentData = function(category,city) {
		var url = '';
		if(city!='all'){
			url = config.domain + '/api/v1/seo/recent_data?&category_slug='+category+'&city_slug='+city;
		}else{
			url = config.domain + '/api/v1/seo/recent_data?&category_slug='+category;
		}
		// +'&city_id='+city;
			return $http.get(url);
		}
	return getRecentData;
});
